import { z } from "zod/v4";
const AmountSchema = z.int().brand();
export const Amount = {
    schema: AmountSchema,
    of(args) {
        return Amount.schema.parse(args);
    },
};
/** プラス金額のみ */
const PositiveAmountSchema = z
    .number()
    .int()
    .nonnegative()
    .brand()
    .brand();
export const PositiveAmount = {
    schema: PositiveAmountSchema,
    of(args) {
        return PositiveAmount.schema.parse(args);
    },
};
/** マイナス金額のみ */
const NegativeAmountSchema = z
    .number()
    .int()
    .nonpositive()
    .brand()
    .brand();
export const NegativeAmount = {
    schema: NegativeAmountSchema,
    of(args) {
        return NegativeAmount.schema.parse(args);
    },
};
//# sourceMappingURL=amount.js.map